/* Snugry theme — vanilla JS, no dependencies */
(function () {
  'use strict';
  var S = window.Snugry || {};
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var store = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    var fmt = S.moneyFormat || '£{{amount}}';
    var value = (Number(cents) / 100);
    var withDelims = function (n, dec, thou, decSep) {
      var parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.join(decSep);
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
        default: return withDelims(value, 2, ',', '.');
      }
    });
  }
  function escapeHtml(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }

  /* ---------- Theme toggle ---------- */
  $$('[data-theme-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var html = document.documentElement;
      var next = html.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
      html.setAttribute('data-theme', next);
      store.set('snugry-theme', next);
    });
  });

  /* ---------- Desktop dropdowns: close on outside click / when another opens ---------- */
  document.addEventListener('click', function (e) {
    $$('.nav-dropdown[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });
  $$('.nav-dropdown').forEach(function (d) {
    d.addEventListener('toggle', function () { if (d.open) $$('.nav-dropdown[open]').forEach(function (o) { if (o !== d) o.removeAttribute('open'); }); });
  });

  /* ---------- Drawers ---------- */
  var lastFocus = null;
  function openDrawer(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var f = el.querySelector('button, a, input, textarea');
    if (f) setTimeout(function () { f.focus(); }, 50);
  }
  function closeDrawer(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(document.getElementById(opener.getAttribute('data-drawer-open'))); }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) { closeDrawer(closer.closest('[data-drawer]')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      $$('[data-drawer].is-open').forEach(closeDrawer);
      var pop = $('[data-popup].is-open'); if (pop) closePopup(pop);
    }
  });

  /* ---------- Announcement rotation ---------- */
  $$('[data-announcement]').forEach(function (bar) {
    var items = $$('.announcement__item', bar);
    if (items.length < 2) return;
    var i = 0, speed = (parseInt(bar.getAttribute('data-speed'), 10) || 5) * 1000;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, speed);
  });

  /* ---------- Christmas countdown ---------- */
  $$('[data-xmas-countdown]').forEach(function (el) {
    var parts = (el.getAttribute('data-cutoff') || '').split('-');
    if (parts.length !== 3) return;
    var cutoff = new Date(+parts[0], +parts[1] - 1, +parts[2], 23, 59, 59);
    var now = new Date();
    if (isNaN(cutoff) || now > cutoff) return;
    var days = Math.ceil((cutoff - now) / 86400000);
    var dateStr = cutoff.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
    var txt = (el.getAttribute('data-template') || '').replace('{date}', dateStr);
    el.textContent = txt + (days <= 14 ? ' · ' + days + (days === 1 ? ' day left' : ' days left') : '');
    el.hidden = false;
  });

  /* ---------- Delivery estimate ---------- */
  function addWorkingDays(date, n) {
    var d = new Date(date);
    while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; }
    return d;
  }
  $$('[data-delivery-estimate]').forEach(function (el) {
    var min = parseInt(el.getAttribute('data-min'), 10), max = parseInt(el.getAttribute('data-max'), 10);
    if (!min || !max) return;
    var opts = { weekday: 'short', day: 'numeric', month: 'short' };
    var a = addWorkingDays(new Date(), min).toLocaleDateString('en-GB', opts);
    var b = addWorkingDays(new Date(), max).toLocaleDateString('en-GB', opts);
    var span = el.querySelector('span');
    if (span) span.innerHTML = 'Order today, arrives <strong>' + a + ' – ' + b + '</strong>';
  });

  /* ---------- Cart ---------- */
  var drawer = $('[data-cart-drawer]');
  var cartStrings = {};
  var tpl = $('[data-cart-strings]');
  if (tpl) $$('[data-k]', tpl.content).forEach(function (n) { cartStrings[n.getAttribute('data-k')] = n.textContent.trim(); });
  var upsells = [];
  var upsellJson = $('[data-upsell-json]');
  if (upsellJson) { try { upsells = JSON.parse(upsellJson.textContent); } catch (e) {} }
  if (!Array.isArray(upsells)) upsells = upsells ? [upsells] : [];

  function fetchJSON(url, opts) {
    return fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }, opts || {}))
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function getCart() { return fetchJSON(S.routes.cart + '.js'); }

  function updateShipBars(total) {
    if (!S.freeShipping || !S.freeShipping.enabled || !S.freeShipping.threshold) return;
    var t = S.freeShipping.threshold, remaining = t - total, pct = Math.min(100, Math.round(total / t * 100));
    $$('[data-ship-bar]').forEach(function (bar) {
      bar.classList.toggle('is-complete', remaining <= 0);
      var fill = $('[data-ship-fill]', bar); if (fill) fill.style.width = pct + '%';
      var text = $('[data-ship-text]', bar);
      if (text) text.innerHTML = remaining > 0 ? S.strings.freeShippingAway.replace(/\{\{\s*amount\s*\}\}/, '<strong>' + formatMoney(remaining) + '</strong>') : S.strings.freeShippingDone;
    });
  }

  function renderCart(cart) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count > 0 ? cart.item_count : ''; el.setAttribute('data-count', cart.item_count); });
    updateShipBars(cart.total_price);
    if (!drawer) return;
    var list = $('[data-cart-items]', drawer), footer = $('[data-cart-footer]', drawer), sub = $('[data-cart-subtotal]', drawer);
    if (sub) sub.textContent = formatMoney(cart.total_price);
    if (!cart.items.length) {
      list.innerHTML = '<div class="cart-empty"><p class="muted">' + escapeHtml(cartStrings.empty) + '</p><a class="button" href="' + S.routes.root + 'collections/all">' + escapeHtml(cartStrings.continue) + '</a></div>';
      footer.hidden = true;
    } else {
      footer.hidden = false;
      list.innerHTML = cart.items.map(function (item) {
        var img = item.image ? '<img src="' + item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' + '" alt="' + escapeHtml(item.product_title) + '" width="84" height="84" loading="lazy">' : '';
        var variant = item.product_has_only_default_variant ? '' : '<div class="cart-item__variant">' + escapeHtml(item.variant_title) + '</div>';
        return '<div class="cart-item" data-key="' + item.key + '">' +
          '<a class="cart-item__image" href="' + item.url + '">' + img + '</a>' +
          '<div><a class="cart-item__title" href="' + item.url + '">' + escapeHtml(item.product_title) + '</a>' + variant +
          '<div class="qty"><button type="button" data-change="' + (item.quantity - 1) + '" aria-label="' + escapeHtml(cartStrings.decrease) + '">&minus;</button><input type="number" value="' + item.quantity + '" min="0" aria-label="Quantity" data-qty-direct><button type="button" data-change="' + (item.quantity + 1) + '" aria-label="' + escapeHtml(cartStrings.increase) + '">+</button></div>' +
          ' <button type="button" class="link-button" data-change="0" style="margin-left:8px">' + escapeHtml(cartStrings.remove) + '</button></div>' +
          '<div class="cart-item__price">' + formatMoney(item.final_line_price) + '</div></div>';
      }).join('');
    }
    var up = $('[data-cart-upsell]', drawer);
    if (up) {
      var upsell = null;
      for (var u = 0; u < upsells.length; u++) {
        var cand = upsells[u];
        if (!cart.items.some(function (i) { return i.product_id === cand.product_id; })) { upsell = cand; break; }
      }
      if (upsell && cart.items.length) {
        var vs = upsell.variants || [];
        var picker = vs.length > 1 ? '<select class="select cart-upsell__select" data-upsell-variant aria-label="' + escapeHtml(upsell.title) + '">' + vs.map(function (v) { return '<option value="' + v.id + '" data-price="' + v.price + '">' + escapeHtml(v.title) + '</option>'; }).join('') + '</select>' : '';
        up.hidden = false;
        up.innerHTML = '<div class="cart-upsell">' + (upsell.image ? '<img src="' + upsell.image + '" alt="" width="64" height="64">' : '<span></span>') +
          '<div><div class="cart-upsell__label">' + escapeHtml(cartStrings.upsell) + '</div><a href="' + upsell.url + '" style="font-weight:600;text-decoration:none">' + escapeHtml(upsell.title) + '</a><div class="muted" data-upsell-price>' + formatMoney(upsell.price) + '</div>' + picker + '</div>' +
          '<button type="button" class="button button--small" data-upsell-add="' + upsell.variant_id + '">' + escapeHtml(cartStrings.add) + '</button></div>';
      } else { up.hidden = true; up.innerHTML = ''; }
    }
  }

  function changeLine(key, qty) {
    return fetchJSON(S.routes.cartChange + '.js', { method: 'POST', body: JSON.stringify({ id: key, quantity: Math.max(0, qty) }) }).then(renderCart);
  }
  function addItems(items) {
    return fetchJSON(S.routes.cartAdd + '.js', { method: 'POST', body: JSON.stringify({ items: items }) })
      .then(getCart).then(function (cart) { renderCart(cart); if (S.cartDrawer && drawer) openDrawer(drawer); else window.location.href = S.routes.cart; return cart; });
  }

  S.addItems = addItems;

  /* ---------- Complete the set ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-set-add]');
    if (!b) return;
    var row = b.closest('[data-set-item]'), sel = row && $('[data-set-variant]', row);
    var label = b.textContent;
    b.disabled = true; b.textContent = S.strings.adding || 'Adding…';
    addItems([{ id: +(sel ? sel.value : b.getAttribute('data-set-add')), quantity: 1 }])
      .then(function () { b.textContent = S.strings.added || 'Added'; setTimeout(function () { b.textContent = label; b.disabled = false; }, 1800); })
      .catch(function () { b.textContent = label; b.disabled = false; });
  });
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-set-variant]')) return;
    var o = e.target.selectedOptions[0], pr = $('[data-set-price]', e.target.closest('[data-set-item]'));
    if (o && pr) pr.textContent = formatMoney(o.getAttribute('data-price'));
  });

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var ch = e.target.closest('[data-change]');
      if (ch) { var row = ch.closest('[data-key]'); changeLine(row.getAttribute('data-key'), parseInt(ch.getAttribute('data-change'), 10)); }
      var ua = e.target.closest('[data-upsell-add]');
      if (ua) { var usel = $('[data-upsell-variant]', ua.closest('.cart-upsell')); ua.disabled = true; addItems([{ id: +(usel ? usel.value : ua.getAttribute('data-upsell-add')), quantity: 1 }]); }
    });
    drawer.addEventListener('change', function (e) {
      if (e.target.matches('[data-qty-direct]')) { var row = e.target.closest('[data-key]'); changeLine(row.getAttribute('data-key'), parseInt(e.target.value, 10) || 0); }
      if (e.target.matches('[data-upsell-variant]')) { var uo = e.target.selectedOptions[0], upr = $('[data-upsell-price]', e.target.closest('.cart-upsell')); if (uo && upr) upr.textContent = formatMoney(uo.getAttribute('data-price')); }
      if (e.target.matches('[data-cart-note]')) { fetchJSON(S.routes.cart + '/update.js', { method: 'POST', body: JSON.stringify({ note: e.target.value }) }); }
    });
  }
  $$('[data-cart-open]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (!S.cartDrawer || !drawer) return;
      e.preventDefault(); openDrawer(drawer);
    });
  });
  if (drawer) getCart().then(renderCart).catch(function () {});

  /* ---------- Product ---------- */
  $$('[data-product-section]').forEach(function (section) {
    var dataEl = $('[data-product-json]', section);
    if (!dataEl) return;
    var data; try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var form = $('form.product-form', section);
    var idInput = $('[data-variant-id]', section);
    var addBtn = $('[data-add-button]', section);
    var priceEl = $('.product__price [data-price]', section);
    var errorEl = $('[data-form-error]', section);
    var sticky = $('[data-sticky-atc]', section);
    var isHero = !/\/products\//.test(window.location.pathname);

    function currentOptions() {
      var groups = {};
      $$('input[data-option-index]:checked', section).forEach(function (i) { groups[i.getAttribute('data-option-index')] = i.value; });
      return Object.keys(groups).sort().map(function (k) { return groups[k]; });
    }
    function findVariant(opts) {
      return data.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
    }
    function showMedia(id) {
      if (!id) return;
      $$('.gallery__slide', section).forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-media-id') == id); });
      $$('[data-thumb]', section).forEach(function (t) { t.setAttribute('aria-current', t.getAttribute('data-thumb') == id ? 'true' : 'false'); });
    }
    function markAvailability(opts) {
      $$('input[data-option-index]', section).forEach(function (input) {
        var idx = +input.getAttribute('data-option-index');
        var test = opts.slice(); test[idx] = input.value;
        var v = findVariant(test);
        input.classList.toggle('is-unavailable', !v || !v.available);
      });
    }
    function onChange() {
      var opts = currentOptions();
      opts.forEach(function (val, i) { var l = $('[data-option-label="' + i + '"]', section); if (l) l.textContent = val; });
      var v = findVariant(opts);
      markAvailability(opts);
      if (!v) {
        addBtn.disabled = true; addBtn.textContent = S.strings.unavailable;
        return;
      }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? S.strings.addToCart : S.strings.soldOut;
      if (priceEl) {
        var html = '<span class="price__current">' + formatMoney(v.price) + '</span>';
        if (v.compare_at_price > v.price) html += '<span class="price__compare">' + formatMoney(v.compare_at_price) + '</span><span class="price__save">Save ' + formatMoney(v.compare_at_price - v.price) + '</span>';
        priceEl.innerHTML = html;
      }
      if (sticky) { var sp = $('[data-sticky-price]', sticky); if (sp) sp.textContent = formatMoney(v.price); var sb = $('[data-sticky-add]', sticky); if (sb) sb.disabled = !v.available; }
      showMedia(v.media_id);
      if (!isHero && window.history.replaceState) {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url.toString());
      }
    }
    section.addEventListener('change', function (e) { if (e.target.matches('input[data-option-index]')) onChange(); });
    if ($('input[data-option-index]', section)) markAvailability(currentOptions());

    section.addEventListener('click', function (e) {
      var t = e.target.closest('[data-thumb]'); if (t) showMedia(t.getAttribute('data-thumb'));
      var qInput = $('[data-qty-input]', section);
      if (e.target.closest('[data-qty-minus]') && qInput) qInput.value = Math.max(1, (parseInt(qInput.value, 10) || 1) - 1);
      if (e.target.closest('[data-qty-plus]') && qInput) qInput.value = (parseInt(qInput.value, 10) || 1) + 1;
      if (e.target.closest('[data-sticky-add]')) { if (form.requestSubmit) form.requestSubmit(addBtn); else addBtn.click(); }
    });

    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (errorEl) errorEl.hidden = true;
      var qty = parseInt(($('[data-qty-input]', section) || {}).value, 10) || 1;
      var original = addBtn.textContent;
      addBtn.disabled = true; addBtn.textContent = S.strings.adding;
      addItems([{ id: +idInput.value, quantity: qty }])
        .then(function () { addBtn.textContent = S.strings.added; setTimeout(function () { addBtn.textContent = original; addBtn.disabled = false; }, 1500); })
        .catch(function (err) {
          addBtn.textContent = original; addBtn.disabled = false;
          if (errorEl) { errorEl.textContent = (err && (err.description || err.message)) || 'Something went wrong. Please try again.'; errorEl.hidden = false; }
        });
    });

    if (sticky && addBtn && 'IntersectionObserver' in window) {
      var footer = $('.site-footer');
      var addVisible = true, footerVisible = false;
      var update = function () { var show = !addVisible && !footerVisible; sticky.classList.toggle('is-visible', show); sticky.setAttribute('aria-hidden', show ? 'false' : 'true'); var b = $('[data-sticky-add]', sticky); if (b) b.tabIndex = show ? 0 : -1; };
      new IntersectionObserver(function (en) { addVisible = en[0].isIntersecting || en[0].boundingClientRect.top > 0; update(); }).observe(addBtn);
      if (footer) new IntersectionObserver(function (en) { footerVisible = en[0].isIntersecting; update(); }).observe(footer);
    }
  });

  /* ---------- Bundle ---------- */
  $$('[data-bundle]').forEach(function (b) {
    var totalEl = $('[data-bundle-total]', b), btn = $('[data-bundle-add]', b);
    function calc() {
      var checked = $$('input[type="checkbox"]:checked', b);
      var sum = checked.reduce(function (s, c) { return s + (+c.getAttribute('data-price')); }, 0);
      totalEl.textContent = formatMoney(sum);
      btn.disabled = checked.length === 0;
    }
    b.addEventListener('change', calc); calc();
    btn.addEventListener('click', function () {
      var items = $$('input[type="checkbox"]:checked', b).map(function (c) { return { id: +c.value, quantity: 1 }; });
      if (!items.length) return;
      btn.disabled = true;
      addItems(items).then(function () { btn.disabled = false; }).catch(function () { btn.disabled = false; });
    });
  });

  /* ---------- Collection sort ---------- */
  $$('[data-sort-by]').forEach(function (sel) {
    sel.addEventListener('change', function () { var u = new URL(window.location.href); u.searchParams.set('sort_by', sel.value); u.searchParams.delete('page'); window.location.href = u.toString(); });
  });

  /* ---------- Newsletter popup ---------- */
  function closePopup(p) { p.classList.remove('is-open'); store.set('snugry-popup', '1'); document.body.style.overflow = ''; }
  $$('[data-popup]').forEach(function (p) {
    p.addEventListener('click', function (e) { if (e.target.closest('[data-popup-close]')) closePopup(p); });
    if ($('[data-popup-success]', p) || window.location.hash === '#PopupForm' || window.location.hash === '#contact_form') {
      if ($('[data-popup-success]', p)) { p.classList.add('is-open'); return; }
    }
    if (store.get('snugry-popup')) return;
    var delay = (parseInt(p.getAttribute('data-delay'), 10) || 12) * 1000;
    setTimeout(function () { if (!$('[data-drawer].is-open')) { p.classList.add('is-open'); store.set('snugry-popup', '1'); } }, delay);
  });

  /* ---------- Login: recover password toggle ---------- */
  $$('[data-show-recover]').forEach(function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); var r = $('[data-recover]'); if (r) r.hidden = !r.hidden; });
  });
  if (window.location.hash === '#recover') { var r = $('[data-recover]'); if (r) r.hidden = false; }
})();

/* Collection intro: clamp long descriptions with a read-more toggle */
(function () {
  document.querySelectorAll('[data-collection-intro]').forEach(function (wrap) {
    var text = wrap.querySelector('.collection-intro__text');
    var btn = wrap.querySelector('.collection-intro__toggle');
    if (!text || !btn) return;
    if (text.scrollHeight - text.clientHeight > 4) btn.hidden = false;
    btn.addEventListener('click', function () {
      var open = text.classList.toggle('is-clamped') === false;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? btn.dataset.less : btn.dataset.more;
    });
  });
})();
